import updateHistory from './update-history';

// Function copied from gravity-blocks Gravity global functions - Needed for Filters index.js
export default function clearUrl(addHistoryEntry = false) {
    updateHistory(window.location.pathname, addHistoryEntry);
}
